function FirebaseIcon({ width = '100px', height = '100px', color = '#000000' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 100 100">
    <path d="M32.1351 23.6817L29.0063 26.5786L26.1021 20.7507L27.6024 17.3997C27.9816 16.7312 28.6018 16.7224 28.981 17.3997L32.1351 23.6817Z" fill="#FFA000"/>
    <path d="M29.0076 26.5774L17.3043 37.4022L26.1034 20.7507L29.0076 26.5774Z" fill="#F57F17"/>
    <path d="M35.5657 19.2511C36.1262 18.7201 36.7033 18.8992 36.8491 19.6534L39.8916 37.2559L29.8003 43.2806C29.4464 43.4774 28.5079 43.5543 28.5079 43.5543C28.5079 43.5543 27.6544 43.4509 27.3272 43.2718L17.3043 37.4022L35.5657 19.2511Z" fill="#FFCA28"/>
    <path d="M26.1033 20.7507L17.3043 37.4022L21.2257 13.0637C21.3728 12.3095 21.8027 12.2326 22.1908 12.901L26.1033 20.7507Z" fill="#FFA000"/>
    </svg>

  );
}

export default FirebaseIcon;
